export const environment = {
  production: false,
  existingCaseWorthyAPIURL:
  "https://staging.cw.caseworthy.net/CaseWorthy.API/",
nextGenAccountsAPIURL: "https://staging.api.cwe.cw.caseworthy.net/account/services/v1/",
nextGenFormsAPIURL: "https://staging.api.cwe.cw.caseworthy.net/forms/services/v1/",
nextGenQueryAPIURL: "https://staging.api.cwe.cw.caseworthy.net/query-apbuilder/services/v1/",
nextGenServerUrl: "https://staging.api.cwe.cw.caseworthy.net/",
};